module.exports = __webpack_public_path__ + "static/media/metrics.657e7fc7.png";